// 获取模块主要获取数据模块
import request from '@/utils/request';

// 获取金币的数据
export const goldCoins = () => request({url: '/look/gold/getGoldCoinModuleInfo', method: 'get'})

// 查询
export const searchGold = (searchName) => request({url: `/look/gold/getGoldCoinModuleInfo?name=${searchName}`, method: 'get'});

// switch操作
export const handleSwitch = (data) => request({url: '/look/gold/updateGoldCoinModule', method: 'put', data});